import { useEffect, useState } from 'react';

export function useMapLoaded(map) {
  const [loaded, setLoaded] = useState();

  useEffect(() => {
    if (!map) return;
    window.google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
      setLoaded(true);
    });
  }, [map]);

  return loaded;
}
